/**
 * Plotly 주요 Method의 Override 구현
 */

import BriqueChart from './BriqueChart.vue'
import Plotly from 'plotly.js-dist'

console.log(Plotly)

export default {
  __proto__: Plotly, // Plotly의 기능 상속
  Fx: Plotly.Fx,

  /**
   * Plotly.newPlot()를 override
   * @override
   * @param {String} elId 차트 Element의 ID
   * @param {Object} oTraces Chart의 Data
   * @param {Object} oLayout Chart의 Layout
   * @param {Object} oConfig Chart의 Config
   * @param {Boolean} oBriquechartOption BriqueChart만의 옵션
   * @param {Boolean} isShowLoadingBar 로딩바를 표시할지 여부
   * @returns Chart Element
   */
  async newPlot (elId, oTraces, oLayout = {}, oConfig = {}, oBriquechartOption = {}, isShowLoadingBar = true) {
    let element = document.getElementById(elId)

    if (element !== null) {
      BriqueChart.G_LOADING_BAR = BriqueChart.G_LOADING_BAR || window.app.__vue__.$store.getters.loadingBars.gLoadingBar// Store에 있는 Global 로딩바(App.vue에서 설정함)
      BriqueChart.G_LOADING_BAR.show()
      element.layout = undefined// 차트를 그린적이 없는 상태로 함
      element.data = undefined// 차트를 그린적이 없는 상태로 함

      let promise = new Promise((resolve) => {
        setTimeout(async () => {
        // let modeBarButtons = ['toImage', 'select2d', 'zoom2d', 'pan2d', 'zoomIn2d', 'zoomOut2d', 'resetScale2d', 'hoverClosestCartesian', 'hoverCompareCartesian']
        // let modeBarButtons = []

          // oConfig.modeBarButtons = [_.cloneDeep(this.modeBarButtons)]
          this.defaultConfig.modeBarButtons = BriqueChart.getModeBarButtons(element)
          let config = _.merge({}, this.defaultConfig, oConfig)

          // layout.automargin = true
          // layout.autosize = true

          // 백만건 이상이면 Data Sampling 적용
          let totalCount = 0
          let traces = oTraces
          for (let trace of oTraces) {
            totalCount += trace.x?.length ?? 0
          }

          // 호출하는 곳에서 설정한  briqueChartOption 적용
          let briqueChartOption = _.merge({}, this.briqueChartOption, oBriquechartOption)
          let briqueChartData = _.cloneDeep(this.briqueChartData)

          // 호출하는 곳에서 설정한 Layout 적용
          let layout = BriqueChart.initLayout(element, oLayout, this.defaultLayout, briqueChartOption)

          // 옵션값을 꺼내 쓰기 위해 세팅한다.
          element.briqueChartOption = briqueChartOption
          element.briqueChartData = briqueChartData

          BriqueChart.setXMinMax(element, oTraces, layout)
          BriqueChart.setYMinMax(element, oTraces, layout)

          briqueChartData.tracesOriginal = oTraces
          briqueChartData.tracesOriginalAfterXAxisDataSelection = oTraces
          briqueChartData.layoutOriginal = layout
          briqueChartData.configOriginal = config

          // 호출하는 곳에서 설정한 Data Option 적용
          oTraces = BriqueChart.initDataOption(oTraces, this.defaultDataOption, layout, briqueChartData)

          BriqueChart.setLayoutFromLegendPosition(element, layout, briqueChartOption)

          if (totalCount >= element.briqueChartOption.data.samplingData.totalCountForSamplingDataOnInit) {
            traces = await BriqueChart.samplingData(element, isShowLoadingBar)
          }

          super.newPlot(elId, traces, layout, config)

          briqueChartData.initSeriesStyles(traces)
          BriqueChart.initTooltipMode(element)
          BriqueChart.applyTooltipMode(element)

          BriqueChart.initPointContextMenu(element)
          BriqueChart.initLegendContextMenu(element)

          if (briqueChartOption.legend.position === 'bottom' || briqueChartOption.legend.position === 'left') {
          // Legend의 위치를 다시 계산한다
            BriqueChart.setLayoutFromLegendPosition(element, element.layout, briqueChartOption)
            BriqueChart.relayout(element, element.layout, isShowLoadingBar)
          }

          // const modeBarButtons = BriqueChart.getModeBarButtons(element)
          // BriqueChart.initModeBarButtons(element, modeBarButtons)
          BriqueChart.initModeBarButtons(element, config.modeBarButtons)
          BriqueChart.restyleModeBarButtons(element)

          // Plotly가 그린 범례의 위치 보정
          BriqueChart.restyleLegend(element)

          element.splitCharts = []

          BriqueChart.initXAxis(element)
          BriqueChart.initYAxis(element)

          // element.on('plotly_click', function (data) {
          //   console.log(data)
          //   // var pts = ''
          //   // for (var i = 0; i < data.points.length; i++) {
          //   //   pts = 'x = ' + data.points[i].x + '\ny = ' +
          //   //         data.points[i].y.toPrecision(4) + '\n\n'
          //   // }
          //   // alert('Closest point clicked:\n\n' + pts)
          // })

          element.on('plotly_afterplot', function () {
          // console.log('plotly_afterplot')
          // Bar 차트에서 값이 음수이어도 맨 아래부터 그려지게 함
            if (element.briqueChartOption.data.bar.zeroBase === true) return
            if (element.briqueChartData.yMinForPad >= 0) return

            // let pathElements = element.querySelector(`.plot .trace.bars .point path`)
            // for (let pathElement of pathElements) {
            //   let path = pathElement.getAttribute('d') // M147.22,710.6V604.03H182.91V710.6Z
            //   let x1 = path.substring(path.indexOf('M') + 1, path.indexOf(',')) // 147.22
            //   // let y1 = path.substring(path.indexOf(',') + 1, path.indexOf('V'))// 710.6
            //   let y2 = path.substring(path.indexOf('V') + 1, path.indexOf('H')) // 604.03
            //   let x2 = path.substring(path.indexOf('H') + 1, path.lastIndexOf('V')) // 182.91

            //   let newY1 = element.clientHeight
            //   let newPath = `M${x1},${newY1}V${y2}H${x2}V${newY1}Z`
            //   pathElement.setAttribute('d', newPath)
            // }

            for (let i = 0; i < element.data.length; i++) {
              let trace = element.data[i]
              if (trace.type === 'bar' && (trace.orientation || 'v') === 'v') {
                let len = trace.y.length
                for (let j = 0; j < len; j++) {
                // if (trace.y[j] >= 0) continue

                  let pathElement = element.querySelector(`.plot .trace.bars:nth-child(${i + 1}) .point:nth-child(${j + 1}) path`)
                  if (_.isEmpty(pathElement)) break
                  let path = pathElement.getAttribute('d') // M147.22,710.6V604.03H182.91V710.6Z
                  let x0 = path.substring(path.indexOf('M') + 1, path.indexOf(',')) // 147.22
                  // let y0 = path.substring(path.indexOf(',') + 1, path.indexOf('V'))// 710.6
                  let y1 = path.substring(path.indexOf('V') + 1, path.indexOf('H')) // 604.03
                  let x1 = path.substring(path.indexOf('H') + 1, path.lastIndexOf('V')) // 182.91

                  let newY1 = element.clientHeight
                  let newPath = `M${x0},${newY1}V${y1}H${x1}V${newY1}Z`
                  pathElement.setAttribute('d', newPath)
                }
              }
            }
          })

          element.on('plotly_relayout', function (data) {
            // console.log('plotly_relayout')
            BriqueChart.restyleModeBarButtons(element)

            // 버튼 Active 여부
            let samplingDataButton = BriqueChart.getModeBarButton(element, 'samplingData')
            if (samplingDataButton.active) {
              // Zoom 또는 Reset axes
              if (data['xaxis.range[0]'] !== undefined || data['xaxis.range[1]'] !== undefined || data['yaxis.range[0]'] !== undefined || data['yaxis.range[1]'] !== undefined) {
                BriqueChart.samplingDataDebounce(element, data['xaxis.range[0]'], data['yaxis.range[0]'], data['xaxis.range[1]'], data['yaxis.range[1]'], true)
              } else if (data['xaxis.range'] !== undefined) { // Range View에서 조정시
                BriqueChart.samplingDataDebounce(element, data['xaxis.range'][0], undefined, data['xaxis.range'][1], undefined, true)
              }
            }
          })

          element.on('plotly_selected', function (data) {
            if (!data || !data.range) return

            // select2d에서 mode가 lines일때는 points에 값이 들어오지 않음

            // 선택한 영역 색 지정
            let rect = _.find(element.layout.shapes, (item) => { return item.shapeName === 'briquechart_selection_rect' })

            if (_.isUndefined(rect)) {
              element.layout.shapes = element.layout.shapes ?? []
              rect = _.merge({}, element.briqueChartData.selection.rect)

              element.layout.shapes.push(rect)
            }

            rect.x0 = data.range.x[0]
            rect.x1 = data.range.x[1]
            rect.y0 = data.range.y[0]
            rect.y1 = data.range.y[1]
            rect.visible = true

            BriqueChart.relayout(element, { shapes: element.layout.shapes }, false)
          })

          element.on('plotly_deselect', function (data) {
            console.log('plotly_deselect')
            // 영역 색 지정한것을 보이지 않게 함
            let index = _.findIndex(element.layout.shapes, (item) => { return item.shapeName === 'briquechart_selection_rect' })

            if (index >= 0) {
              element.layout.shapes.splice(index, 1)
              BriqueChart.relayout(element, { shapes: element.layout.shapes }, false)
            }
          })

          resolve()
        }, 50)// end - setTimeout
      })// end - new Promise

      await promise
      BriqueChart.G_LOADING_BAR.hide() // Store에 있는 로딩바

      return promise
    }
  }, // end - newPlot

  /**
   * Plotly.react()를 override
   *
   * Plotly.react() 대신 BriqueChart.react()를 호출해야 LoadingBar가 적용된다.
   * @override
   * @param {Object} element Chart Element
   * @param {Object} data Chart Data
   * @param {Object} layout Chart Layout
   * @param {Object} config Chart Config
   * @param {Boolean} isShowLoadingBar 로딩바를 표시할지 여부
   */
  async react (element, data, layout, config, isShowLoadingBar = true) {
    if (isShowLoadingBar) BriqueChart.G_LOADING_BAR.show()
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    layout = layout ?? element.layout
    config = config ?? element._context

    let seriesStyles = element.briqueChartData.seriesStyles.filter((seriesStyle) => {
      return data.some(trace => trace.name === seriesStyle.name)
    })

    let promise = new Promise((resolve) => {
      setTimeout(() => {
        if (seriesStyles) {
          Plotly.react(element, _.merge([], data, seriesStyles), layout, config)
        } else {
          Plotly.react(element, data, layout, config)
        }
        resolve()
      }, 50)
    })

    await promise

    BriqueChart.restyleModeBarButtons(element)
    if (isShowLoadingBar) BriqueChart.G_LOADING_BAR.hide()

    return promise
  },

  /**
   * Plotly.relayout()를 override
   * Plotly.relayout()에 briqueChartOption Parameter가 추가됨
   *
   * Plotly.relayout() 대신 BriqueChart.relayout()를 호출해야 LoadingBar가 적용된다.
   * @override
   * @param {Object} element Chart Element
   * @param {Object} layout Chart Layout
   * @param {Boolean} isShowLoadingBar 로딩바를 표시할지 여부
   */
  async relayout (element, layout, isShowLoadingBar = true) {
    if (_.isEmpty(element)) return
    BriqueChart.G_LOADING_BAR = BriqueChart.G_LOADING_BAR || window.app.__vue__.$store.getters.loadingBars.gLoadingBar// Store에 있는 Global 로딩바(App.vue에서 설정함)
    if (isShowLoadingBar) BriqueChart.G_LOADING_BAR.show()
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    let promise = new Promise((resolve) => {
      setTimeout(() => {
        try {
          Plotly.relayout(element, layout)
        } catch (e) {
        // Plotly에서 에러가 나는 경우 있지만 무시함
        // console.log(`Plotly.relayout Error : e`)
        }
        resolve()
      }, 50)
    })

    await promise
    if (isShowLoadingBar) BriqueChart.G_LOADING_BAR.hide()

    let briqueChartOption = element.briqueChartOption
    if (briqueChartOption.legend?.position === 'right' || briqueChartOption.legend?.position === 'left') {
      briqueChartOption.legend.width = element.querySelector(`.legend`)?.getBBox().width ?? 0
    }

    if (briqueChartOption.legend?.position === 'top' || briqueChartOption.legend?.position === 'bottom') {
      briqueChartOption.legend.height = element.querySelector(`.legend`)?.getBBox().height ?? 0
    }

    return promise
  },

  /**
   * Plotly.restyle()를 override
   *
   * Plotly.restyle() 대신 BriqueChart.restyle()를 호출해야 LoadingBar가 적용된다.
   * @override
   * @param {Object} element Chart Element
   * @param {Object} dataStyle Chart의 Trace 부분의 Style
   * @param {Object} traceIndices 적용할 Series의 index 배열
   * @param {Boolean} isShowLoadingBar 로딩바를 표시할지 여부
   */
  async restyle (element, dataStyle, traceIndices, isShowLoadingBar = true) {
    if (isShowLoadingBar) BriqueChart.G_LOADING_BAR.show()
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    let promise = new Promise((resolve) => {
      setTimeout(() => {
        Plotly.restyle(element, dataStyle, traceIndices)
        resolve()
      }, 50)
    })

    await promise
    if (isShowLoadingBar) BriqueChart.G_LOADING_BAR.hide()

    return promise
  },

  /**
   * Plotly.extendTraces()를 override
   *
   * @override
   * @param {Object} element Chart Element
   * @param {Object} addData 추가 데이터
   * @param {Array} indices Trace Indices
   * @param {Integer} maxPoints 최대 확장할 포인트
   * @param {Boolean} isApplyXMinMax X축 Min, Max를 차트에 적용할 지 여부
   * @param {Boolean} isApplyXMinMax Y축 Min, Max를 차트에 적용할 지 여부
   */
  extendTraces (element, addData, indices, maxPoints, isApplyXMinMax = false, isApplyYMinMax = true) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    Plotly.extendTraces(...arguments)

    BriqueChart.setXMinMaxForExtendTraces(element, addData, isApplyXMinMax)
    BriqueChart.setYMinMaxForExtendTraces(element, addData, isApplyYMinMax)

    BriqueChart.relayout(element, { 'yaxis.range': element.layout.yaxis.range }, false)
  },

  /**
   * Plotly.prependTraces()를 override
   *
   * @override
   * @param {Object} element Chart Element
   * @param {Object} addData 추가 데이터
   * @param {Array} indices Trace Indices
   * @param {Integer} maxPoints 최대 확장할 포인트
   * @param {Boolean} isApplyXMinMax X축 Min, Max를 차트에 적용할 지 여부
   * @param {Boolean} isApplyXMinMax Y축 Min, Max를 차트에 적용할 지 여부
   */
  prependTraces (element, addData, indices, maxPoints, isApplyXMinMax = false, isApplyYMinMax = true) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    Plotly.prependTraces(...arguments)

    BriqueChart.setXMinMaxForExtendTraces(element, addData, isApplyXMinMax)
    BriqueChart.setYMinMaxForExtendTraces(element, addData, isApplyYMinMax)

    BriqueChart.relayout(element, { 'yaxis.range': element.layout.yaxis.range }, false)
  },

  /**
   * Plotly.purge()를 override
   * @param {*} element Chart Element
   */
  purge (element) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)
    Plotly.purge(element)
  }
}
